import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProviderService, Provider } from 'src/app/services/provider.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-provider-detail',
    templateUrl: './provider-detail.component.html',
    styleUrls: ['./provider-detail.component.css']
})
export class ProviderDetailComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private providerService: ProviderService,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
    ) { }

    // Misma paleta que el listado de proveedores (provider-list), para que
    // el color del avatar de un proveedor sea consistente entre ambas vistas.
    private readonly avatarPalette = [
        { bg: '#eef2ff', color: '#4f46e5' },
        { bg: '#e6fbf3', color: '#10b981' },
        { bg: '#fffbeb', color: '#d97706' },
        { bg: '#e6f0ff', color: '#0066ff' },
        { bg: '#fdf2f8', color: '#db2777' },
        { bg: '#f5f3ff', color: '#8b5cf6' },
        { bg: '#fff7ed', color: '#ea580c' },
        { bg: '#fee2e2', color: '#ef4444' },
    ];

    providerId!: number;
    provider: Provider | null = null;
    tab: 'general' | 'historial' = 'general';

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (!id) {
            this.router.navigateByUrl('/provider/list');
            return;
        }
        this.providerId = Number(id);
        this.loadProvider();
    }

    setTab(tab: 'general' | 'historial'): void {
        this.tab = tab;
    }

    loadProvider(): void {
        this.spinner.show();
        this.providerService.getProvider(this.providerId).subscribe({
            next: (resp: any) => {
                this.provider = resp?.data || null;
                this.spinner.hide();
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo cargar el proveedor', icon: 'error' });
            }
        });
    }

    initials(): string {
        const name = this.provider?.trade_name || this.provider?.business_name || '';
        return name.trim().charAt(0).toUpperCase() || '?';
    }

    get avatarBg(): string {
        return this.avatarPalette[(this.provider?.id || 0) % this.avatarPalette.length].bg;
    }

    get avatarColor(): string {
        return this.avatarPalette[(this.provider?.id || 0) % this.avatarPalette.length].color;
    }
}
